<template>
    <div class="places locator__places">
        <locator-contact-list v-bind="$props"/>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {getLocation} from './helpers/geolocation';
    import LocatorContactList from './ContactList';

    export default {
        name: 'LocatorContactContainer',
        components: {
            LocatorContactList
        },
        props: {
            onSelect: {
                type: Function | null,
                default: null,
            },
            selectedContactId: {
                type: String | Number | null,
                default: null,
            }
        },
        mounted() {
            this.fetchContactProcess(true);
            getLocation()
                .then(coords => this.setCoords(coords))
                .finally(() => this.fetchContacts())
        },
        methods: {
            ...mapActions('locator', ['setCoords', 'fetchContacts', 'fetchContactProcess'])
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/locator/ContactContainer.vue